<div>
    <p>{{ "casoVerify.content" | transloco }}</p>
</div>